import * as types from '../../types';

export const WATCHED_AREA_FIELD_KEYS: (keyof types.PropertyFormValues)[] = [
  'masterProperty',
  'portfolio',
  'area',
  'countryId',
  'coords',
  'address',
  'tags',
  'id',
];
